@if (form) {
  @if (createCard) {
    <ng-casto-card-type-choice
      [form]="form"
      [withPremium]="withPremium"
      [withFree]="(!this.updateData && !this.updateDataValidation) || withFree"></ng-casto-card-type-choice>
    <ng-casto-customer-type-choice [form]="form"></ng-casto-customer-type-choice>
  }

  <div class="form-card form-card-large" [formGroup]="form" [ngClass]="{ disabled: form.value?.memberType === '' }">
    <h2 class="form-title">
      <span class="icon"></span>
      <span [innerHtml]="'popins.signup.new-form.vendor-title' | translate"></span>
    </h2>
    <div class="form-group">
      <!-- Mail -->
      <div class="form-row">
        <div class="form-col">
          <label for="mail" class="required" [innerHtml]="'popins.signup.new-form.email' | translate"></label>
          <div class="casto-input-group">
            <input class="casto-input" formControlName="email" type="email" name="mail" id="mail" />
            <button [disabled]="!this.form.controls['email'].valid" (click)="searchMail()">
              <div>
                <div class="spinner-border" role="status" *ngIf="emailLoading"></div>
                <svg *ngIf="!emailLoading && !isEmailSearched">
                  <use xlink:href="assets/img/icons.svg#icon-action-search"></use>
                </svg>
                <svg *ngIf="isEmailSearched">
                  <use xlink:href="assets/img/icons.svg#icon-action-success"></use>
                </svg>
              </div>
            </button>
          </div>
          <small class="error" *ngIf="form.get('email').errors?.taken">L'e-mail est déjà utilisé</small>
        </div>
      </div>

      <!-- Civility -->
      <div class="form-row form-inline">
        <label class="required" [innerHtml]="'popins.signup.new-form.civility' | translate"></label>

        <input
          type="radio"
          name="honorificPrefix"
          id="monsieur"
          [value]="HonorificPrefix.Monsieur"
          [ngClass]="{ readonly: !isEmailSearched }"
          formControlName="honorificPrefix" />
        <label for="monsieur">M.</label>

        <input
          type="radio"
          name="honorificPrefix"
          id="madame"
          [value]="HonorificPrefix.Madame"
          [ngClass]="{ readonly: !isEmailSearched }"
          formControlName="honorificPrefix" />
        <label for="madame">Mme</label>

        <input
          type="radio"
          name="honorificPrefix"
          id="mademoiselle"
          [value]="HonorificPrefix.Mademoiselle"
          [ngClass]="{ readonly: !isEmailSearched }"
          formControlName="honorificPrefix" />
        <label for="madame">Mlle</label>
      </div>

      <!-- Last Name -->
      <div class="form-row">
        <div class="form-col">
          <label for="lastName" class="required" [innerHtml]="'popins.signup.new-form.last-name' | translate"></label>
          <input
            class="casto-input"
            type="text"
            name="lastName"
            id="lastName"
            [readonly]="!isEmailSearched"
            formControlName="lastName" />
        </div>
      </div>

      <!-- First Name -->
      <div class="form-row">
        <div class="form-col">
          <label for="firstName" class="required" [innerHtml]="'popins.signup.new-form.first-name' | translate"></label>
          <input
            class="casto-input"
            type="text"
            name="firstName"
            id="firstName"
            [readonly]="!isEmailSearched"
            formControlName="firstName" />
        </div>
      </div>

      <!-- Phone Number -->
      <div class="form-row">
        <div class="form-col">
          <label
            for="phoneNumber"
            [ngClass]="{ required: isRequired('phoneNumber') }"
            [innerHtml]="'popins.signup.new-form.phone-number' | translate"></label>
          <input
            class="casto-input"
            [readonly]="!isEmailSearched"
            formControlName="phoneNumber"
            type="text"
            name="phoneNumber"
            id="phoneNumber" />
          <small
            class="error"
            *ngIf="form.get('phoneNumber').errors?.pattern"
            [innerHtml]="'popins.signup.new-form.phone-number-error' | translate"></small>
        </div>
      </div>

      <!-- Country -->
      <div class="form-row">
        <div class="form-col">
          <label
            for="country"
            [ngClass]="{ required: isRequired('country') }"
            [innerHtml]="'popins.signup.new-form.country' | translate"></label>
          <select class="casto-input" name="country" formControlName="country" id="country">
            <option *ngFor="let country of prioCountries" [value]="country.value">
              {{ country.label }}
            </option>
            <option disabled>__________</option>
            <option *ngFor="let country of otherCountries" [value]="country.value">
              {{ country.label }}
            </option>
          </select>
        </div>
      </div>

      <!-- Address -->
      <div class="form-row form-row-inline-sm">
        <div class="form-col">
          <label
            for="houseNumber"
            [ngClass]="{ required: isRequired('houseNumber') }"
            [innerHtml]="'popins.signup.new-form.house-number' | translate"></label>
          <input
            class="casto-input"
            maxlength="10"
            type="text"
            name="houseNumber"
            id="houseNumber"
            [readonly]="!isEmailSearched"
            formControlName="houseNumber" />
        </div>
        <div class="form-col form-col-large">
          <label
            for="address"
            [ngClass]="{ required: isRequired('address') }"
            [innerHtml]="'popins.signup.new-form.street' | translate"></label>
          <input
            class="casto-input"
            [readonly]="!isEmailSearched"
            formControlName="address"
            type="text"
            name="address"
            id="address" />
        </div>
      </div>

      <div class="form-row form-row-inline-sm">
        <!-- Postal Code -->
        <div class="form-col">
          <label
            for="postal"
            [ngClass]="{ required: isRequired('postalCode') }"
            [innerHtml]="'popins.signup.new-form.postal-code' | translate"></label>
          <input
            class="casto-input"
            type="text"
            name="postal"
            id="postal"
            [readonly]="!isEmailSearched"
            formControlName="postalCode" />
        </div>

        <!-- City -->
        <div class="form-col form-col-large">
          <label
            for="city"
            [ngClass]="{ required: isRequired('city') }"
            [innerHtml]="'popins.signup.new-form.city' | translate"></label>
          <input class="casto-input" type="text" name="city" [readonly]="!isEmailSearched" formControlName="city" />
        </div>
      </div>

      <small
        class="form-row-error error"
        *ngIf="form.get('postalCode').errors?.notExist || form.get('postalCode').errors?.pattern"
        [innerHtml]="'popins.signup.new-form.postal-code-error' | translate">
      </small>

      <div class="form-row form-row-inline-sm">
        <div class="form-col">
          <label
            for="buildingFloorStaircase"
            [innerHtml]="'popins.signup.new-form.building-floor-staircase' | translate"></label>
          <input
            class="casto-input"
            formControlName="buildingFloorStaircase"
            type="text"
            name="buildingFloorStaircase"
            [readonly]="!isEmailSearched"
            id="buildingFloorStaircase" />
        </div>
        <div class="form-col">
          <label for="localityPoBox" [innerHtml]="'popins.signup.new-form.locality-po-box' | translate"></label>
          <input
            class="casto-input"
            type="text"
            name="localityPoBox"
            [readonly]="!isEmailSearched"
            id="localityPoBox"
            formControlName="localityPoBox" />
        </div>
      </div>

      <!-- Birth Date -->
      <div class="form-row">
        <div class="form-col">
          <label for="birthDate" [innerHtml]="'popins.signup.new-form.birth-date' | translate"></label>
          <input
            type="date"
            name="birthDate"
            [readonly]="!isEmailSearched"
            id="birthDate"
            formControlName="birthDate"
            class="casto-input" />
        </div>
        <div class="form-col"></div>
      </div>

      @if (!createCard && !updateData) {
        <!-- With Fidelity Card -->
        <div class="form-row">
          <input
            type="checkbox"
            name="withFidelityCard"
            id="withFidelityCard"
            formControlName="withFidelityCard"
            [readonly]="!isEmailSearched"
            class="casto-input checkbox" />

          <label [innerHtml]="'popins.signup.new-form.with-fidelity-card' | translate"></label>
        </div>
      }
    </div>
    @if (showChoiceCustomer) {
      <ng-casto-customer-type-choice [form]="form"></ng-casto-customer-type-choice>
    }

    <div class="form-actions">
      @if (showBackToLogin) {
        <ng-casto-btn
          class="light-grey mr-2"
          (click)="login()"
          [label]="'popins.signup.link2' | translate"></ng-casto-btn>
      }
      <ng-casto-btn
        class="blue"
        [disabled]="form.invalid"
        [label]="'Enregistrer'"
        [loading]="isLoading"
        (click)="submit()"></ng-casto-btn>
      <ng-casto-btn class="light-grey" [label]="'Annuler'" [loading]="isLoading" (click)="close()"></ng-casto-btn>
    </div>
  </div>
}
